import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';


export function homesiteSliders() {
  document.addEventListener( 'DOMContentLoaded', function () {

    if(document.querySelector('.homepage__section5__slider')) {
      var homesiteSlider = new Splide( '.homepage__section5__slider', {
        type       : 'loop',
        
        // heightRatio: 1,
        perPage : 1,
        pagination : false,
        arrows     : true,
        // cover      : true,
      } ).mount();
    }

    if(document.querySelector('.homepage__section6__repeater')) {
      var homesiteSlider2 = new Splide( '.homepage__section6__repeater', {
        type       : 'loop',
        
        // heightRatio: 1,
        perPage : 3,
        perMove: 1,
        pagination : false,
        arrows     : true,
        breakpoints: {
          1200: {
            perPage: 2,
          },
          950: {
            perPage: 1,
          },
        }
        // cover      : true,
      } );
      
      homesiteSlider2.on('mounted', ()=>{
        if(homesiteSlider2.length <= homesiteSlider2.options.perPage && homesiteSlider2.options.arrows == true) {
          homesiteSlider2.options = { arrows: false };
          homesiteSlider2.destroy();
          homesiteSlider2.mount();
        }
      })
      
      homesiteSlider2.mount();
    }
  })
}